import { Control, UseFormHandleSubmit } from "react-hook-form";

import {
  formUpdateAnagrafica,
  inputCognome,
  inputNome,
  labelAnagrafica,
  snackbarDetailUpdatesSaved,
  snackbarSummaryUpdatesSaved,
} from "_constants";
import { TextInput } from "components/shared";
import { updateAnagrafica } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { getDecodedToken, setTokenInStorage } from "utils";
import { useAppDispatch } from "store/store";
import { setUserProfile } from "store/slicer/ProfiloSlice";

export const FormAnagrafica = ({
  control,
  handleSubmit,
}: {
  control: Control<
    {
      name: string;
      lastName: string;
      email: string;
    },
    any
  >;
  handleSubmit: UseFormHandleSubmit<
    {
      name: string;
      lastName: string;
      email: string;
    },
    undefined
  >;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const onSubmit = (formData: any) => {
    updateAnagrafica({ name: formData.name, lastName: formData.lastName })
      .then((response) => {
        setTokenInStorage(response.data.accessToken);

        let decodedToken = getDecodedToken();
        dispatch(
          setUserProfile({
            token: response.data.accessToken,
            firstName: decodedToken?.firstName,
            lastName: decodedToken?.lastName,
            email: decodedToken?.userName,
            role: decodedToken?.role,
          })
        );
        showSnackbar({
          severity: "success",
          summary: snackbarSummaryUpdatesSaved,
          detail: snackbarDetailUpdatesSaved,
          life: 5000,
        });
      })
      .catch((_) => {});
  };

  return (
    <form
      id={formUpdateAnagrafica}
      onSubmit={handleSubmit(onSubmit)}
      className="width-100 flex-container column gap-8"
    >
      <span className="text-base-bold">{labelAnagrafica.toUpperCase()}</span>
      <div className="flex-container gap-8">
        <TextInput control={control} name="name" placeholder={inputNome} />
        <TextInput
          control={control}
          name="lastName"
          placeholder={inputCognome}
        />
      </div>
    </form>
  );
};
